export default __webpack_public_path__ + "static/media/not-found.763c0091.gif";